(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("l1OKo", function(module, exports) {
var $f4f10e54d3e71e07$var$tabsGroups = document.querySelectorAll(".g-tabs");
var $f4f10e54d3e71e07$var$externalTabsButtons = document.querySelectorAll("[data-tabs-target]:not(.g-tabs__button)");
var $f4f10e54d3e71e07$var$mobileQuery = window.matchMedia("(max-width: 74.999em)");
$f4f10e54d3e71e07$var$externalTabsButtons.forEach(function(button) {
    var target = button.dataset.tabsTarget;
    if (!target) return;
    button.addEventListener("click", function(e) {
        e.preventDefault();
        var tabButton = document.querySelector(".g-tabs__button[data-tabs-target=".concat(target, "]"));
        if (!tabButton) return;
        tabButton === null || tabButton === void 0 || tabButton.dispatchEvent(new Event("click"));
        window.scrollTo({
            top: tabButton.offsetTop,
            behavior: "smooth"
        });
    });
});
$f4f10e54d3e71e07$var$tabsGroups.forEach(function(tabs) {
    var buttons = tabs.querySelectorAll(".g-tabs__button");
    var activeButton = tabs.querySelector(".g-tabs__button.--active");
    var panels = tabs.querySelectorAll(".i-tab");
    var contentWrapper = tabs.querySelector(".g-tabs__content");
    var openTab = function(button, scrollTo) {
        if (scrollTo === void 0) scrollTo = false;
        var target = button.dataset.tabsTarget;
        if (!target) return;
        var targetPanel = tabs.querySelector("#".concat(target, ".i-tab"));
        if (!targetPanel) return;
        buttons.forEach(function(button) {
            button.classList.remove("--active");
        });
        button.classList.add("--active");
        panels.forEach(function(panel) {
            return panel.classList.remove("--open");
        });
        targetPanel.classList.add("--open");
        if ($f4f10e54d3e71e07$var$mobileQuery.matches) button.after(targetPanel);
        else panels.forEach(function(panel) {
            contentWrapper.appendChild(panel);
        });
        if (scrollTo) setTimeout(function() {
            window.scrollTo({
                top: targetPanel.offsetTop,
                behavior: "smooth"
            });
        }, 300);
    };
    buttons.forEach(function(button) {
        button.addEventListener("click", function() {
            return openTab(button, true);
        });
    });
    $f4f10e54d3e71e07$var$mobileQuery.onchange = function() {
        openTab(activeButton);
    };
    openTab(activeButton);
});

});

})();
//# sourceMappingURL=tabs-group.bb5aac55.js.map
